import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";

export default {
    mixins: [mainRegistrationMixin],
    methods: {
        getOrfValue(orfName, orfType) {
            try {
                let value = this.eventData.onlineRegistrationFields[this.getOrfKey(orfName, orfType)]

                if (value === undefined) {
                    let field = this.onlineRegistrationFields.find((field) => field.Typ === orfType && field.Name === orfName)

                    if (field) {
                        value = field.preset
                    } else {
                        value = 0
                    }
                }

                return value
            } catch (e) {
                return 0
            }
        },
        getOrfKey(orfName, orfType) {
            let field = this.onlineRegistrationFields.find((field) => field.Typ === orfType && field.Name === orfName)
            if (field) {
                return field.key
            }
        }
    },
    computed: {
        invoiceRecipient1417() {
            return this.eventData?.invoiceRecipient1417
        },
        multipleRegistration() {
            return this.eventData?.multipleRegistration
        },
        noParticipants() {
            return this.eventData?.noParticipants
        },
        registrationWhenFullyBooked() {
            return this.eventData?.registrationWhenFullyBooked
        },
        onlyPersonsAsParticipants() {
            return this.eventData?.onlyPersonsAsParticipants
        },
        invoiceRecipientTypeRestriction() {
            return this.eventData?.invoiceRecipientTypeRestriction
        },
        diverseSalutation() {
            return this.eventData?.diverseSalutation
        },
        oneParticipantPerRegistration() {
            return this.eventData?.oneParticipantPerRegistration
        },
        canSeeAddParticipantButton() {
            if (this.$store.getters['registration/isGroupRegistrar']) return true
            return !this.oneParticipantPerRegistration || this.participatingPersons?.length < 1
        }
    }
}
